module.exports = __webpack_public_path__ + "static/media/genie2.d76588ff.webm";